<mat-card *ngIf="status === 'ENTER_KEY'" class="enter-key">
    <h2 *ngIf="type === 'ACTIVATION'">Aktivierung</h2>
    <h2 *ngIf="type === 'LOST_PW'">Neues Passwort vergeben</h2>
    <h2 *ngIf="type === 'NEW_EMAIL'">Neue E-Mail-Adresse validieren</h2>
    <form (ngSubmit)="onSubmit()">
        <p>
            <mat-form-field color="accent">
                <input matInput type="text" name="key" id="key" [formControl]="keyFormControl" autocomplete="false"
                    placeholder="{{type === 'ACTIVATION' ? 'Aktivierungs-Code' : 'Freigabe-Code'}}" required />
                <mat-error *ngIf="keyFormControl.hasError('key_valid')">

                    <span *ngIf="type === 'ACTIVATION'">Der Aktivierungs-Code ist ungültig.</span>
                    <span *ngIf="type === 'LOST_PW'">Der Freigabe-Code ist ungültig.</span>
                    <span *ngIf="type === 'NEW_EMAIL'">Der Validierungs-Code ist ungültig.</span>
                </mat-error>
                <mat-error *ngIf="keyFormControl.hasError('required')">
                    <span *ngIf="type === 'ACTIVATION'">Bitte geben Sie Ihren Aktivierungs-Code ein.</span>
                    <span *ngIf="type === 'LOST_PW'">Bitte geben Sie Ihren Freigabe-Code ein.</span>
                    <span *ngIf="type === 'NEW_EMAIL'">Bitte geben Sie Ihren Validierungs-Code ein.</span>
                </mat-error>
            </mat-form-field>
        </p>
        <p>
            <button mat-flat-button color="accent" type="submit" #submitKey id="submitKey">
                <span *ngIf="type === 'ACTIVATION'">Aktivierung abschließen</span>
                <span *ngIf="type === 'LOST_PW'">Passwort-Freigabe anfordern</span>
                <span *ngIf="type === 'NEW_EMAIL'">E-Mail-Validierung abschließen</span>
            </button>
        </p>
    </form>
</mat-card>


<mat-card *ngIf="status === 'ENTER_PWD'" class="enter-pwd">
    <h2>Passwort vergeben</h2>
    <form #credForm id="credForm" (ngSubmit)="onSubmit()">
        <p>
            <mat-form-field color="accent">
                <input matInput
                       [type]="hidePW ? 'password' : 'text'"
                       name="password" [formControl]="passwordFormControl"
                       placeholder="Passwort"
                       required (focusout)="onFocusOut()"
                       (focus)="onFocus()" />
                <fa-icon class="show-pw push-right" [icon]="['fas', (hidePW?'eye':'eye-slash')]" #tooltip="matTooltip"
                         (click)="hidePW = !hidePW" matTooltipPosition="above"
                    matTooltip="Passwort anzeigen">
                </fa-icon>
                <fa-icon class="info-btn" [icon]="['fas', 'info']" #tooltip="matTooltip" matTooltipPosition="above"
                    matTooltip="min. 8 Zeichen, min. 1 Kleinbuchstaben, min. 1 Großbuchstaben, min. 1 Zahl, min. 1 Sonderzeichen ( @$+.()/\#;:_-=!%*?&)">
                </fa-icon>
                <mat-error *ngIf="passwordFormControl.hasError('pattern') && !passwordFormControl.hasError('required')">
                    Das Passwort erfüllt nicht die Mindestanforderungen.
                </mat-error>
                <mat-error *ngIf="passwordFormControl.hasError('required')">
                    Bitte geben Sie ein Passwort ein.
                </mat-error>
            </mat-form-field>
        </p>

        <p>
            <mat-form-field color="accent">
                <input matInput
                       [type]="hidePWconfirm ? 'password' : 'text'"
                       name="passwordValidation"
                       placeholder="Passwort wiederholen"
                       [formControl]="passwordValidationFormControl" required />
                <fa-icon class="show-pw" [icon]="['fas', (hidePWconfirm?'eye':'eye-slash')]" #tooltip="matTooltip" matTooltipPosition="above"
                         (click)="hidePWconfirm = !hidePWconfirm" matTooltip="Passwort anzeigen">
                </fa-icon>
                <mat-error *ngIf="!pwdMatch">
                    Ihr Eingabe stimmt nicht überein.
                </mat-error>
                <mat-error *ngIf="passwordValidationFormControl.hasError('required')">
                    Bitte geben Sie Ihr Passwort erneut ein.
                </mat-error>
                <mat-error *ngIf="passwordValidationFormControl.hasError('pwd_validated')">
                    Ihre eingegebenen Passwörter stimmen nicht überein.
                </mat-error>
            </mat-form-field>
        </p>

        <p>
            <button mat-flat-button color="accent" type="submit">
                <span *ngIf="type === 'ACTIVATION'">Registrierung abschließen</span>
                <span *ngIf="type === 'LOST_PW'">Passwort vergeben</span>
            </button>
        </p>
    </form>
</mat-card>
